import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      textAlign: 'center',
      padding: '15px',
    }}>
      <div style={{ marginBottom: '10px' }}>
        <a href="/terms" style={{ color: 'white', marginRight: '20px', textDecoration: 'none' }}>Terms</a>
        <a href="/privacy" style={{ color: 'white', textDecoration: 'none' }}>Privacy Policy</a>
      </div>
      <p style={{ color: 'white', fontSize: '0.8em', opacity: 0.7 }}>© {currentYear} Event Spy. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
